import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAirportCharges } from "../store/slices/carrentalpackage";
// import cardImg from '../assets/img/carImg-card.png';
import Footer from "./Footer";
import Navbarsticky from "./NavbarSticky";
import { Form, Col, Container, Row } from "react-bootstrap";

import { GiCommercialAirplane } from "react-icons/gi";

const AirportBooking = () => {
  const query = new URLSearchParams(useLocation().search);

  const placeId = query.get("placeId");
  const hotelName = query.get("hotelName");
  const pickupDate = query.get("pickupDate");
  const isSwapped = query.get("isSwapped") === "true";

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [vehicleList, setVehicleList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  // Fetch vehicles
  useEffect(() => {
    if (placeId) {
      setLoading(true);
      dispatch(getAirportCharges({ place: placeId }))
        .unwrap()
        .then((data) => {
          const responseData = data?.airportCharges;
          const route = responseData;

          setVehicleList(route);
        })
        .catch(() => {
          setVehicleList([]);
        })
        .finally(() => setLoading(false));
    }
  }, [dispatch, placeId]);

  console.log("vehiclelist:", vehicleList);

  return (
    <>
      {/* Navbar */}
      <Navbarsticky />
      <div className="airportbooking-container"></div>
      <div className="container mt-5 mb-5">
        {/* search bar */}
        <div className="pd-form d-flex flex-wrap align-item-center justify-content-around my-4 mx-2 px-2">
          {/* pickup location */}
          <Form.Group className="mb-1 mx-1 p-3">
            <Form.Label className="pd-filter-label">Pickup Location</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                value="AirportBooking"
                placeholder="AirportBooking"
              />
              <GiCommercialAirplane />
            </div>
          </Form.Group>

          {/* <span className="horizontal-line-pd">|</span> */}

          {/* hotel name   */}
          <Form.Group className="mb-3 mx-1 p-3">
            <Form.Label className="pd-filter-label"> Hotel </Form.Label>

            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                defaultValue={hotelName}
                placeholder="Hotel Name"
              />
              <i class="bi bi-buildings"></i>
            </div>
          </Form.Group>

          {/* <span className="horizontal-line-pd">|</span> */}

          {/* pickup location */}
          <Form.Group className="mb-1 mx-1 p-3">
            <Form.Label className="pd-filter-label">Pickup:</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                defaultValue={pickupDate?.replace("T", " ")}
                placeholder={pickupDate?.replace("T", " ")}
              />
              <i class="bi bi-geo-alt-fill"></i>
            </div>
          </Form.Group>

          {/* <span className="horizontal-line-pd">|</span> */}

          {/* transfer */}
          <Form.Group className="mb-1 mx-1 p-3">
            <Form.Label className="pd-filter-label">Transfer</Form.Label>
            <div className="input-with-icon-pd">
              <input
                type="text"
                className="pd-filter-input"
                defaultValue={isSwapped ? "Airport → Hotel" : "Hotel → Airport"}
                placeholder={isSwapped ? "Airport → Hotel" : "Hotel → Airport"}
              />
              <i className="bi bi-arrow-left-right"></i>
            </div>
          </Form.Group>

          <Form.Group className="mb-1 mx-1 p-3">
            <Link to="/carrental">
              <button className="pickupdrop-search-btn">
                Modify Search &nbsp;<i className="bi bi-search"></i>
              </button>
            </Link>
          </Form.Group>
        </div>

        {/* vehile Card */}
        <div className="container my-5">
          <Container className="column main-area">
            <Row>
              <Col lg={12} md={12}>
                <div className="results-header d-flex align-items-center justify-content-between">
                  <div>
                    {loading && <p>Loading vehicle list...</p>}

                    {!loading && vehicleList?.carData?.length === 0 && (
                      <p className="text-danger">
                        No vehicles available for this route.
                      </p>
                    )}
                  </div>
                </div>

                {/* card list */}

                <Row xs={1} sm={2} md={3} lg={3} className="g-4 mt-2">
                  {vehicleList?.carData?.map((item) =>
                    item?.vehicle?.map((carItem) => {
                      const car = carItem.vehicle; // vehicle details
                      const price = carItem.price; // price

                      return (
                        <Col
                          key={car._id}
                          lg={4}
                          md={4}
                          sm={6}
                          xs={12}
                          className="mb-4"
                        >
                          <div
                            className={`vehicle-card ${
                              selectedVehicle?._id === car._id
                                ? "vehicle-selected"
                                : ""
                            }`}
                            onClick={() =>
                              setSelectedVehicle({
                                _id: car._id,
                                name: car.carName,
                                image: car.carImage,
                                price: price,
                              })
                            }
                          >
                            {/* Image */}
                            <div className="vehicle-img-box">
                              <img
                                src={car.carImage}
                                alt={car.carName}
                                className="vehicle-img"
                              />
                              <span className="vehicle-badge">
                                Premium Ride
                              </span>
                            </div>

                            {/* Content */}
                            <div className="vehicle-body">
                              <h5 className="vehicle-title">{car.carName}</h5>

                              <p className="vehicle-seat-info">
                                <i className="bi bi-people-fill me-1"></i>
                                {car.minMember} – {car.maxMember} Seats
                              </p>

                              <div className="vehicle-price-wrap">
                                <h5 className="vehicle-price">₹ {price}</h5>
                              </div>

                              <button className="vehicle-btn w-100 mt-2">
                                Book Now →
                              </button>
                            </div>
                          </div>
                        </Col>
                      );
                    })
                  )}
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* footer */}

      <Footer />
    </>
  );
};

export default AirportBooking;
